import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Visibility from '@material-ui/icons/Visibility'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {confirmAlert} from "react-confirm-alert";
import ScheduleComponent from "../Parts/ScheduleComponent";
import SignatureCanvas from "react-signature-canvas";
import {Tooltip} from "@material-ui/core";
import APPCONFIG from "../../constants/Config";

export default class ScheduleApprovals extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Schedule_Approvals._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.filterDate = this.props.initialDate ? moment(this.props.initialDate).format('YYYY-MM-DD') : moment().add(2, 'weeks').day(0).format('YYYY-MM-DD');
		this.state.selectedData = null;
		this.sigPad = null;
		this.state.selectedUsers = [];
		this.state.user = [];
		this.signatureCanvasProps = {width: 450, height: 208, className: 'sigCanvas'};
		this.state.invalidSignature = false;
	}

	clearSigPad = () => {
		this.sigPad.clear();
	};

	getSigPadRef = (ref) => {
		if (!ref) return;
		this.sigPad = ref;
	}

	clearSigPadRef = () => {
		confirmAlert({
			title: "Confirm Clear Signature",
			message: "Are you sure you want to clear this signature?",
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.clearSigPad()
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	async componentDidMount() {
		await this.fetchData(this.state)
	}

	async componentDidUpdate(prevState, prevProps, snapshot) {

	}

	loadSelfAfter(data) {
		if (this.sigPad && data.signature) {
			this.sigPad.fromDataURL(data.signature, {width: 450, height: 208});
		}
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	fetchData = async (state) => {
		this.state.sorted = [];
		this.state.page = 0;
		this.state.limit = 15;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.week_of = this.state.filterDate;
		this.state.filter.user = this.props.id;
		this.state.filter.filterUsers = this.state.selectedUsers; //.map((item) => item.value);
		this.setState({loading: true, selectedData: null, data: []});
		window.setTimeout(() => {
			this.fetchDataActual(state, ['tors']);
		}, 100);
	}

	handleSelectPropertyUpdate = async (property, value, linked, object) => {
			this.setState({
				[property]: value,
				[property + '_error']: '',
				selectedUsers: [...value].filter((value, index, self) => self.indexOf(value) === index),
			}, () => {this.fetchData(this.state).then()});
	};

	render() {
		const {data, pages, limit, loading, tors} = this.state;
		let object = this.state;
		/** @type {Schedule_Approvals_Properties} properties */
		let properties = this.model.properties;
		const columns =
			[
				{
					Header: "User",
					id: "user",
					/** @param {Schedule_Approvals_Object} obj */
					accessor: obj => obj?.ica_data ? obj.name : obj.user
				},
				{
					Header: "Signed",
					id: "created",
					/** @param {Schedule_Approvals_Object} obj */
					accessor: obj => moment(obj.created).format('MM/DD/YY h:mm a')
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						if(props.original?.ica_data){
							return (<span></span>);
						}
						return (
							<span>
								<Tooltip title={"View Week"}>
									<Link to={"/executives/approvals/" + props.original.pkey}>
										<Button color="blue-hoki" size={"sm"} block={true}>
											<Visibility fontSize={'small'}/></Button>
									</Link>
								</Tooltip>
							</span>
						);
					}
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						let url = "";
						if(props.original?.ica_data){
							url = APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/forms/results/print_ica/" + props.original.user + "/" + props.original.pkey;

						} else {
							url = APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/forms/results/print_ica/" + props.original.pkey;
						}

						return (
							<span>
								<Button color="blue-hoki" size={"sm"} block={true} onMouseDown={() => window.open(url, "_blank")}>
									<PictureAsPdfIcon fontSize={'small'}/>
								</Button>
							</span>
						);
					}
				}
			]
		return (
			<div className={'box-body'}>
				<div className={'table-bar pb-0'}>
					<div>
						<Modal
							isOpen={this.state.modalSignature}
							toggle={() => this.handleToggleModal('modalSignature')}
							size={"md"}
							backdrop={true}
							title={"Approval Signature"}
						>
							<ModalHeader>
								Approval Signature
							</ModalHeader>
							<ModalBody>
								<div className="form-group">
									<b style={{textAlign: 'center'}}>These are the times I am setting to schedule work.</b>

									{/*Invalid Signature Message*/}
									{this.state.invalidSignature &&
										<div className="alert alert-danger" style={{marginTop: '10px', marginBottom: '10px'}}>
											<em>Signature is required</em>
										</div>
									}

									<div style={{backgroundColor: '#f2f3f4', border: 2}}>
										<SignatureCanvas penColor='black' canvasProps={this.signatureCanvasProps} minWidth={3}
										                 ref={this.getSigPadRef}/>
									</div>
									<Framework.Elements.LoadingSpinner isLoading={loading}/>
									<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
										<Button disabled={loading} color="danger" onClick={() => {
											this.clearSigPadRef();
											this.setState({invalidSignature: false}); //Clear error when clearing signature
										}}>Clear Signature</Button>

										<Button disabled={loading} color="secondary" onClick={() => {
											this.setState({modalSignature: false, invalidSignature: false}) //Clear error on cancel
										}}>Cancel</Button>

										<Button disabled={loading} color="primary" onClick={async () => {
											//Validate signature before saving
											if (this.sigPad.isEmpty()) {
												this.setState({invalidSignature: true});
												return;
											}

											this.setState({loading: true, invalidSignature: false});

											let schedule_model = new API.BuildClass(Types.Schedule_Approvals._name, API.RequestType.CREATE);
											schedule_model.object.user = data[0].user;
											schedule_model.object.week_of = this.state.filterDate;
											schedule_model.object.data_obj = JSON.stringify({
												selectedData: this.state.selectedData,
												filterDate: this.state.filterDate,
												daysOff: data[0].data_obj.daysOff,
												defaultBlocks: data[0].data_obj.defaultBlocks
											});
											schedule_model.object.signature_data = this.sigPad.getCanvas().toDataURL('image/png');
											schedule_model.object.original_data = JSON.stringify(data[0].data_obj);

											await schedule_model.submit(null, 'PUT', true)
											this.setState({modalSignature: false, loading: false})
											await this.fetchData(this.state);
										}}>Save</Button>
									</div>
								</div>
							</ModalBody>
						</Modal>
						<div className="rbc-toolbar pl-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 pb-0">
							<div className="flex gap-1">
								<IconButton disabled={this.state.filterDate === moment().day(0).format("YYYY-MM-DD") && this.props.id} onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).subtract(7, 'day').day(0).format('YYYY-MM-DD')}, async () => {
										await this.fetchData(this.state);
									})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" style={{width: 'auto'}} type="button" onClick={async () => {
									this.setState({filterDate: moment(Date.now()).day(0).format('YYYY-MM-DD')}, async () => {
										await this.fetchData(this.state);
									})
								}}>This Week
								</button>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).add(7, 'day').day(0).format('YYYY-MM-DD')}, async () => {
										await this.fetchData(this.state);
									})
								}}><RightArrowIcon/></IconButton>
							</div>
							<div className={"rbc-toolbar-label text-center sm:text-left"}>
								<label onClick={() => {
									this.handleToggleModal('showDate')
								}}>
									{moment(this.state.filterDate).format('ddd MMM D')} - {moment(this.state.filterDate).add(6, 'days').format('ddd MMM D')}
								</label>
							</div>
							{!this.props.id && <div style={{width: '33rem'}}>

								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.user}
									values={object.user}
									error={''}
									model={Types.Users._name}
									label={"Users"}
									limit={15}
									text={'name_first&name_last'}
									sort={'name_first|name_last'}
									isMulti

								/>

							</div>}
						</div>
					</div>
				</div>
				{/*here should probably instead do if id is passed in first, then if fe that way we can render manager table or fe/everyone else views*/}
				{!this.props.id ? <Card>
					<CardContent>
						<ReactTable
							key={this.state.key}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={data.length}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={1} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							showPagination={false}
							pageSizeOptions={[data.length]}
							defaultPageSize={data.length}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card> : <Card>
					<CardContent>
						{data && data.length > 0 && <div>
							<ScheduleComponent tors={tors ?? []} daysOff={data[0].data_obj.daysOff ?? []} disabled={!!data[0].pkey} isEngineer={this.props.isFe}
							                   defaultDate={this.state.filterDate} returnSelected={(data) => {
								this.setState({selectedData: data})
							}} blocks={data[0].data_obj.defaultBlocks} initialData={data[0].data_obj.selectedData}/>
							<Button disabled={!!data[0].pkey || loading} color="primary" onClick={async () => {
								let schedule_model = new API.BuildClass(Types.Schedule_Approvals._name, API.RequestType.CREATE);
								schedule_model.object.user = data[0].user;
								schedule_model.object.week_of = this.state.filterDate;
								schedule_model.object.data_obj = JSON.stringify({
									selectedData: this.state.selectedData,
									filterDate: this.state.filterDate,
									daysOff: data[0].data_obj.daysOff,
									defaultBlocks: data[0].data_obj.defaultBlocks
								})
								schedule_model.object.original_data = JSON.stringify(data[0].data_obj);
								const res_data = await schedule_model.submit(null, 'PUT_VALIDATE', true)
								if (res_data?.conflictingDays.length > 0) {
									const daysString = res_data.conflictingDays.join(', ');
									confirmAlert({
										title: 'Conflicting Appointments',
										message: `${daysString} had conflicting appointments already booked for you. Please submit a Schedule Adjustment manually.`,
										buttons: [
											{
												label: "Ok",
												color: 'primary',
												onClick: () => {
												}
											},
										]
									});
								} else {
									this.setState({modalSignature: true})
								}
								//await this.fetchData(this.state);
								//instead of above call the faux submit and then pop a modal with the signature if it returns with no issues
							}}>{!!data[0].pkey ? "Approved" : "Save"}</Button>
						</div>}
					</CardContent>
				</Card>}
			</div>
		)
	}
}
